import { useCallback } from 'react';
import Raven from 'raven-js';
import { updateCopilotPreviewFeedback } from '../../../../api/CopilotPreviewV2Api';
const TAG_MAP_COPILOT_V1_TO_V2 = {
  incorrectAction: 'INCORRECT_ACTION',
  notRelevant: 'NOT_RELEVANT',
  incomplete: 'INCOMPLETE',
  inaccurate: 'INACCURATE',
  other: 'OTHER'
};
export const usePreviewsFeedback = (previewKey, previewSource) => {
  const handlePositiveFeedback = useCallback(() => {
    updateCopilotPreviewFeedback({
      previewKey,
      previewSource,
      feedback: {
        polarity: 'POSITIVE'
      }
    }).catch(error => {
      Raven.captureException(new Error('Failed to send positive feedback for simplified previews', error));
    });
  }, [previewKey, previewSource]);
  const handleNegativeFeedback = useCallback(({
    options,
    feedbackMessage
  }) => {
    const formattedCopilotV2Options = options === null || options === void 0 ? void 0 : options.map(option => {
      return TAG_MAP_COPILOT_V1_TO_V2[option];
    });
    updateCopilotPreviewFeedback({
      previewKey,
      previewSource,
      feedback: {
        polarity: 'NEGATIVE',
        tags: formattedCopilotV2Options,
        comment: feedbackMessage
      }
    }).catch(error => {
      Raven.captureException(new Error('Failed to send negative feedback for simplified previews', error));
    });
  }, [previewKey, previewSource]);
  return {
    onPositiveFeedback: handlePositiveFeedback,
    onNegativeFeedback: handleNegativeFeedback
  };
};